import React from "react";
import { connect } from "react-redux";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from "devextreme-react/button";
import TextArea from 'devextreme-react/text-area';
import Popup from "devextreme-react/popup";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import Accordion from 'devextreme-react/accordion';
import '../processing/updateOrderStage.css'
import { alert } from "devextreme/ui/dialog";
import ExportEdiDocumentsPreview from "../genaric-component/ExportEdiDocumentsPreview";
import CommonReport from "../../../reports/components/CommonReport";
import { LoadPanel } from "devextreme-react";
import { CheckBox } from "devextreme-react/check-box";
import SelectBox from "devextreme-react/select-box";


const searchpanel = [
  {
    ID: 1,
    Name: 'Search Filters'
  }
];

let accessToken = "";

class ExportEdiDocuments extends React.Component {
  constructor(props) {
    super(props);
    accessToken = props.oidc.user.access_token;
    this.startButtonClicked = this.startButtonClicked.bind(this);
    this.previewButtonClicked = this.previewButtonClicked.bind(this);
    this.resetButtonClicked = this.resetButtonClicked.bind(this);

    this.initialState = {
      previewData: null,
      report: {
        comment: '',
        filterWhereInfoList: [],
        transactionSet810: true,
        transactionSet855: true,
        transactionSet856: true,
        includeDocumentsAlreadyExported: false
      },
      isPreviewGridPopupVisible: false,
      loadIndicatorVisible: false,
      animationDuration: 300,
      selectedItems: searchpanel,
    };
    this.state = { ...this.initialState };

    this.handleReportStateChange = this.handleReportStateChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClosePreviewPopUpCallback = this.handleClosePreviewPopUpCallback.bind(this);
    this.selectionChanged = this.selectionChanged.bind(this);
  }

  handleReportStateChange = (reportState) => {
    this.setState({
      report: reportState
    });
  }

  handleChange = (field, value) => {
    this.setState((prevState) => ({
      report: {
        ...prevState.report,
        [field]: value
      }
    }));
  }

  handleClosePreviewPopUpCallback = () => {
    this.setState({ isPreviewGridPopupVisible: false });
  }

  selectionChanged = (e) => {
    let newItems = [...this.state.selectedItems];
    e.removedItems.forEach((item) => {
      const index = newItems.indexOf(item);
      if (index >= 0) {
        newItems.splice(index, 1);
      }
    });
    if (e.addedItems.length) {
      newItems = [...newItems, ...e.addedItems];
    }
    this.setState({
      selectedItems: newItems
    });
  }

  startButtonClicked = async (e) => {
    if (e?.event)
      e.event.stopPropagation();
    this.setState({
      loadIndicatorVisible: true,
    });

    try {
      const response = await this.transferDeliveries();
      console.log(response)
      this.setState({ loadIndicatorVisible: false });
      if (response.errors > 0) {
        alert("The State Change Process generated  " + response.errors + "  error message(s).", "Error");
      }
      alert("Records Processed:  " + response, "Process Complete");

    } catch (error) {
      console.error('Error:', error);
      alert("Error: " + error.message, "Error");
    }
    finally {
      this.setState({ loadIndicatorVisible: false });
    }
  };
  transferDeliveries = async () => {
    try {
      const filterWhereInfoList = this.state.report?.filterWhereInfoList || [];

      await this.setState((prevState) => ({
        transferDeliveriesParams: {
          ...prevState.report,
          ['filterWhereInfoList']: filterWhereInfoList,
          ['comment']: prevState.report.comment,
          ['transactionSet810']: prevState.report.transactionSet810,
          ['transactionSet855']: prevState.report.transactionSet855,
          ['transactionSet856']: prevState.report.transactionSet856,
          ['includeDocumentsAlreadyExported']: prevState.report.includeDocumentsAlreadyExported
        }
      }));
      // Make the POST request to the API endpoint
      const res = await axios.post(
        `${window._env_.REACT_APP_APIS}/${routes.OM.CallOMBatchTransferToDispatch}`,
        JSON.stringify(this.state.report),
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return res.data; // Return the response data
    } catch (error) {
      this.setState({
        loadIndicatorVisible: false
      });
      console.error('Error:', error);
      throw error; // Re-throw the error for handling in the component
    }
  };
  PreviewData = async () => {
    try {
      const filterWhereInfoList = this.state.report?.filterWhereInfoList || [];

      // Build request object with all required fields for UpdateOrderStageRequestDto
      // Note: char fields need single character values, not empty strings
      // Property names must match C# DTO (PascalCase)
      const requestData = {
        ToStage: this.state.report?.toStage || ' ',
        ToStatus: this.state.report?.toStatus || ' ',
        ShipQtyMethod: this.state.report?.shipQtyMethod || null,
        FilterWhereInfoList: filterWhereInfoList,
        InvoiceDate: this.state.report?.invoiceDate || null,
        ShippingDate: this.state.report?.shippingDate || null,
        ForceInvDate: this.state.report?.forceInvDate || ' ',
        ForceShipDate: this.state.report?.forceShipDate || ' ',
        Program: this.state.report?.program || null,
        OrderDate: this.state.report?.orderDate || null,
        ForceOrderDate: this.state.report?.forceOrderDate || null,
        Comment: this.state.report?.comment || '',
        TransactionSet810: this.state.report?.transactionSet810 || false,
        TransactionSet855: this.state.report?.transactionSet855 || false,
        TransactionSet856: this.state.report?.transactionSet856 || false,
        IncludeDocumentsAlreadyExported: this.state.report?.includeDocumentsAlreadyExported || false
      };

      const res = await axios.post(
        `${window._env_.REACT_APP_APIS}/${routes.OM.GetExportEdiDocuments}`,
        JSON.stringify(requestData),
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return res.data; // Return the response data
    } catch (error) {
      this.setState({
        loadIndicatorVisible: false
      });
      console.error('Error:', error);
      throw error; // Re-throw the error for handling in the component
    }
  };

  async previewButtonClicked(e) {
    if (e?.event)
      e.event.stopPropagation();
    this.setState({
      loadIndicatorVisible: true
    });
    const data = await this.PreviewData();
    this.setState({
      previewData: data,
      isPreviewGridPopupVisible: true,
      loadIndicatorVisible: false
    });
  }
  resetButtonClicked(e) {
    if (e?.event)
      e.event.stopPropagation();
    this.setState({ ...this.initialState });
  }


  render() {
    return (
      <>
        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          onHiding={(() => this.setState({ loadIndicatorVisible: false }))}
          visible={this.state.loadIndicatorVisible}
          showIndicator={true}
          shading={true}
          showPane={true}
          hideOnOutsideClick={false}
        />
        <div className="row">
          <div className="col-md-12 main-page">
            <div id="accordion" >
              <Accordion
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={this.state.animationDuration}
                selectedItems={this.state.selectedItems}
                onSelectionChanged={this.selectionChanged}
                itemTitleRender={() => (

                  <Toolbar className="accordian-toolbar">
                    <Item location="before">
                      <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          Transfer Deliveries To Dispatch
                        </h6>
                      </div>
                    </Item>

                    <Item location="after">
                      <Button className="accordianButton" text="Start" onClick={this.StartButtonClicked} type="default" />
                    </Item>
                    <Item location="after">
                      <Button className="accordianButton" onClick={this.previewButtonClicked} text="Preview" />
                    </Item>
                    <Item location="after">
                      <Button className="accordianButton" onClick={this.resetButtonClicked} text="Reset" />
                    </Item>
                  </Toolbar>
                )}
                itemRender={(itemProps) => (
                  <div>
                    <div className="row" style={{ padding: '0px', margin: '0px', display: 'flex', alignItems: 'flex-start' }}>
                      <div className="col-md-6" style={{ paddingTop: '0px', marginTop: '0px', verticalAlign: 'top' }}>
                        <div style={{ 
                          borderRadius: '4px',
                          marginTop: '0px',
                          paddingTop: '0px'
                        }}>
                          <h6 style={{ 
                            color: '#1976D2', 
                            marginTop: '0px',
                            marginBottom: '15px',
                            fontWeight: 'bold'
                          }}>
                            Transaction Sets
                          </h6>
                          <div style={{ marginLeft: '10px' }}>
                            <CheckBox
                              value={this.state.report.transactionSet810}
                              text="810 - Invoice"
                              onValueChange={(e) => this.handleChange('transactionSet810', e)}
                              style={{ marginBottom: '10px' }}
                            />
                            <br/>
                            <CheckBox
                              value={this.state.report.transactionSet855}
                              text="855 - Purchase Order Acknowledgment"
                              onValueChange={(e) => this.handleChange('transactionSet855', e)}
                              style={{ marginBottom: '10px' }}
                            />
                             <br/>
                            <CheckBox
                              value={this.state.report.transactionSet856}
                              text="856 - Advances Shipment Notice"
                              onValueChange={(e) => this.handleChange('transactionSet856', e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6" style={{ paddingTop: '0px', marginTop: '0px', verticalAlign: 'top' }}>
                        <div style={{ paddingTop: '0px', marginTop: '0px' }}>
                          <label style={{ 
                            color: '#1976D2', 
                            marginTop: '0px',
                            marginBottom: '10px',
                            display: 'block',
                            fontWeight: 'bold'
                          }}>
                            Include Documents Already Exported?
                          </label>
                          <SelectBox
                            dataSource={[
                              { value: false, text: 'No' },
                              { value: true, text: 'Yes' }
                            ]}
                            displayExpr="text"
                            valueExpr="value"
                            value={this.state.report.includeDocumentsAlreadyExported}
                            onValueChanged={(e) => this.handleChange('includeDocumentsAlreadyExported', e.value)}
                            stylingMode="outlined"
                            width="100%"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                id="accordion-container" className="accordion-height"
              />
            </div>
          </div>
        </div>
        <CommonReport
          name="OMEXPORTEDIDOCUMENTS"
          fullName="OMEXPORTEDIDOCUMENTS"
          state={this.state}
          onReportStateChange={this.handleReportStateChange}
        />
        {this.state.isPreviewGridPopupVisible &&
          <Popup
            visible={this.state.isPreviewGridPopupVisible}
            onHiding={this.handleClosePreviewPopUpCallback}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title={"Preview"}
            container=".dx-viewport"
            closeOnOutsideClick={true}
          >
            <ExportEdiDocumentsPreview dataSource={this.state.previewData} />
          </Popup>
        }
      </>
    );
  }

}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(ExportEdiDocuments);